module.exports = __webpack_public_path__ + "static/v_4-44c919c8308a548756f2576793a69c8e.mp4";